import styled from 'styled-components'

export const Wrapper = styled.div`
    width: 100%;
    ${props => {
        const { color, borderWidth, opacity } = props
        return `border-bottom: ${borderWidth}px solid ${color}; opacity: ${opacity};`
    }}
    padding: 0;
    margin: 0;
`
